type Env = {
	API_URL: string | undefined;
	APP_URL: string | undefined;
	NICHE_PARTNER_PORTAL_URL: string | undefined;
	AUTH0_AUDIENCE: string | undefined;
	AUTH0_CLIENT_ID: string | undefined;
	AUTH0_DOMAIN: string | undefined;
	BIRD_EATS_BUG_APP_ID: string | undefined;
	CHATBOT_TEST_URL: string | undefined;
	CLOUDINARY_API_KEY: string | undefined;
	CLOUDINARY_CLOUD_NAME: string | undefined;
	CUBE_API_URL: string | undefined;
	ENABLE_DATADOG: string | undefined;
	GOOGLE_FONTS_API_KEY: string | undefined;
	GROWTHBOOK_API_KEY: string | undefined;
	GTM_CONTAINER_ID: string | undefined;
	HOTGLUE_API_KEY: string | undefined;
	HOTGLUE_ENV_URL: string | undefined;
	ZENDESK_SNIPPET_KEY: string | undefined;
	IS_LOCAL_VPAGE: string | undefined;
	KEEN_PROJECT_ID: string | undefined;
	KEEN_READ_KEY: string | undefined;
	META_FB_APP_ID: string;
	META_FB_CONFIG_ID: string;
	META_FB_SOLUTION_ID: string;
	NODE_ENV: string | undefined;
	OLD_AUTH0_AUDIENCE: string | undefined;
	OLD_AUTH0_CLIENT_ID: string | undefined;
	OLD_AUTH0_DOMAIN: string | undefined;
	PRID: string | undefined;
	PROPEL_AUTH_URL: string;
	PUSHER_APP_KEY: string;
	SEGMENT_WRITE_KEY: string | undefined;
	UNLAYER_PROJECT_ID: string | undefined;
	VERSION: string | undefined;
	VIDEO_PAGE_URL: string | undefined;
	FLATFILE_PUBLISHABLE_KEY: string | undefined;
};

// Only mock window in non-browser environments (like Node.js for tests)
if (typeof window === 'undefined') {
	global.window = {
		env: {},
		// Add other properties as needed
	} as unknown as Window & typeof globalThis;
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const windowEnv: Env = window.env;
export const env = windowEnv || process.env;
